////smooth scrolling
import { tns } from './tiny-slider';
import { qs, qsa } from './util';

qsa('a[href^="/enterprises/#"]').forEach(anchor => {
  anchor.addEventListener('click', function(e) {
    e.preventDefault();

    const pos = qs(anchor.hash);

    if (window.innerWidth > 767) {
      switch (pos.id) {
        case 'smart-payments':
          window.scrollTo(0, pos.offsetTop + pos.offsetHeight - 100);
          break;
        case 'e2e-payments':
          window.scrollTo(0, pos.offsetTop + pos.offsetHeight + 100);
          break;
        case 'secured-card-transactions':
          window.scrollTo(0, pos.offsetTop + pos.offsetHeight - 150);
          break;
        case 'international-payments':
          window.scrollTo(0, pos.offsetTop + pos.offsetHeight - 10);
          break;
        case 'recurring-payments':
          window.scrollTo(0, pos.offsetTop + pos.offsetHeight - 173);
          break;
        default:
          window.scrollTo(0, pos.offsetTop + pos.offsetHeight);
      }
    } else {
      switch (pos.id) {
        case 'smart-payments':
          window.scrollTo(0, pos.offsetTop + pos.offsetHeight - 100);
          break;
        case 'e2e-payments':
          window.scrollTo(0, pos.offsetTop + pos.offsetHeight + 100);
          break;
        case 'secured-card-transactions':
          window.scrollTo(0, pos.offsetTop + pos.offsetHeight - 280);
          break;
        case 'international-payments':
          window.scrollTo(0, pos.offsetTop + pos.offsetHeight - 380);
          break;
        case 'recurring-payments':
          window.scrollTo(0, pos.offsetTop + pos.offsetHeight - 170);
          break;
        default:
          window.scrollTo(0, pos.offsetTop + pos.offsetHeight);
      }
    }
  });
});

function modalToggle() {
  var modal = document.getElementById('tokenization-modal');
  modal.classList.toggle('show');
}

///youtube links

var iframeSrc = [
  'https://www.youtube.com/embed/ZpoGzZw86Ps?autoplay=1&autohide=1?v=ZpoGzZw86Ps&ab_channel=Razorpay&utm_source=lp&utm_medium=organic&utm_campaign=ftxenterprise',
  'https://www.youtube.com/embed/V5g5hMzp9eQ?autoplay=1&autohide=1?v=V5g5hMzp9eQ&ab_channel=Razorpay&utm_source=lp&utm_medium=organic&utm_campaign=ftxenterprise'
];

////iframe mmodal toggle

function iframeToggle(id = null) {
  var modal = document.getElementById('iframe-modal');
  var source = modal.children[1].children[0].children[0];
  if (id !== null || undefined) {
    source.src = iframeSrc[id];
  } else {
    source.src = '';
  }

  modal.classList.toggle('show');
}

/////form modal toggle

qs('#button-anchor').addEventListener('click', modalToggle);
qs('#button-anchor-overlay').addEventListener('click', modalToggle);
qs('#button-anchor-close').addEventListener('click', modalToggle);
qs('.download-preview').addEventListener('click', function() {
  iframeToggle(1);
}); //TokenHQ
qs('.play-overlay').addEventListener('click', function() {
  iframeToggle();
});

const lightbox = document.querySelector('.lightbox');
document.querySelector('#optimizer-play').addEventListener('click', function() {
  console.log('clicked');
  lightbox.classList.add('active');
  const vid = document.getElementById('optimizer-vid');
  vid.play();
}); // smart payments
document
  .querySelector('.lightbox-background')
  .addEventListener('click', event => {
    const vid = document.getElementById('optimizer-vid');
    vid.pause();
    lightbox.classList.remove('active');
  }); // smart payments

/////scrollspy

let menuSection = document.querySelectorAll('.payment-stack h4:not(.heading)');

// for window scrolldown event

window.onscroll = () => {
  let mainSection = document.querySelectorAll('.payment-section');

  mainSection.forEach((v, i) => {
    let rect = v.getBoundingClientRect().y;
    if (rect < 300) {
      menuSection.forEach(v => v.classList.remove('active'));
      menuSection[i].classList.add('active');
    }
  });
};

//////form
hbspt.forms.create({
  region: 'na1',
  portalId: '5558946',
  formId: '927983d0-81f3-409e-922b-fd800db25d5a',
  target: '#booking_form'
});

///tiny-slider

const tnsCarousel = document.querySelectorAll('.logo-slider');
tnsCarousel.forEach(slider => {
  const tnsSlider = tns({
    container: slider,
    items: 3,
    autoplay: true,
    controls: false,
    nav: false,
    autoplayTimeout: 0,
    speed: 3000,
    preventActionWhenRunning: true
  });
});
